export const PERSON_LOGIN_CLICK='login/PERSON_LOGIN_CLICK';
export const COMPANY_LOGIN_CLICK='login/COMPANY_LOGIN_CLICK';
export const PERSON_LOGIN_BTN_CLICK='login/PERSON_LOGIN_BTN_CLICK';
export const COMPANY_LOGIN_BTN_CLICK='login/COMPANY_LOGIN_BTN_CLICK';
export const CHANGE_PERSON_LOGIN='login/CHANGE_PERSON_LOGIN';
export const CHANGE_COMPANY_LOGIN='login/CHANGE_COMPANY_LOGIN';